import React, { useEffect } from 'react'
import { useNavigation } from '@react-navigation/native'
import { NativeStackScreenProps } from '@react-navigation/native-stack'

import Typography from 'APP/Converse/Typography'

import * as NestedNavHelper from 'APP/Nav/NestedNavHelper'
import I18n from 'APP/I18n'

import { StyledButton, StyledResponsiveView, StyledContainerView } from './style'

export type VideoCallEndedScreenProps = NativeStackScreenProps<
  ReactNavigation.RootParamList,
  'videoCallEnded'
>

const VideoCallEndedScreen = ({ route }: VideoCallEndedScreenProps) => {
  const navigation = useNavigation()
  const { episodeId, caller } = route.params
  const { first_name, last_name } = caller || {}

  useEffect(() => {
    // Remove this screen when the user navigates away or is redirected
    // (e.g., from a chat push notification).
    // We avoid using replace because we don’t want to actively control
    // or override the navigation flow.
    // We also can’t reliably use pop since navigation is nested
    // and we don’t know how many screens would need to be popped.
    // Instead, we remove the screen on blur to let users continue
    // naturally from where they left off.
    const unsubscribe = navigation.addListener('blur', () => {
      NestedNavHelper.removeRouteFromStack('videoCallEnded')
    })

    return unsubscribe
  }, [navigation])

  const onPress = () => {
    if (episodeId) {
      NestedNavHelper.replace('conversation', { channelId: episodeId })
    } else {
      NestedNavHelper.reset({ index: 0, routes: [{ name: 'todayTab' }] })
    }
  }

  return (
    <>
      <StyledContainerView>
        <StyledResponsiveView>
          {first_name && last_name && (
            <Typography variant="h3" color="white">
              {first_name} {last_name}
            </Typography>
          )}
          <Typography variant="bodyNormal" color="white">
            {I18n.t('VideoCallEndedScreen.callEnded')}
          </Typography>
        </StyledResponsiveView>
        <StyledButton
          variant="primary"
          small={false}
          onPress={onPress}
          analyticsName="Close Video Call"
          testID="CLOSE_VIDEO_CALL_SCREEN"
          title={`${I18n.t('VideoCallEndedScreen.done')}`}
          textColor="darkText"
        />
      </StyledContainerView>
    </>
  )
}

export default VideoCallEndedScreen
